import { createContext, ReactNode, useContext, useMemo } from 'react';

import { getPricingAnalyticsProperties, PricingEntryPoint } from '@/shared/lib/pricingAttribution';

const PricingAnalyticsContext = createContext<PricingEntryPoint>('direct_pricing');

export const PricingAnalyticsProvider = ({
  children,
  entryPoint,
}: {
  children: ReactNode;
  entryPoint: PricingEntryPoint;
}) => <PricingAnalyticsContext.Provider value={entryPoint}>{children}</PricingAnalyticsContext.Provider>;

export const usePricingAnalyticsProperties = () => {
  const entryPoint = useContext(PricingAnalyticsContext);
  return useMemo(() => getPricingAnalyticsProperties(entryPoint), [entryPoint]);
};
